import styled from 'styled-components'

export const AutocompleteRoot = styled.form`
  background-color: #ffffff8f;
`
